import { useAuth0 } from '@auth0/auth0-react'
import { LoadingLogo } from '@labrav/react-components'
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

const AUTH0_LOGIN_STUCK_TIMEOUT_MS = 5000

export type Auth0LoginRedirectProps = {
  returnTo?: string
}

const buildStuckLoginRecoveryUrl = (returnTo?: string): string => {
  const recoveryUrl = new URL('/error', window.location.origin)
  recoveryUrl.searchParams.set('reason', 'stuck_login')
  if (returnTo) {
    recoveryUrl.searchParams.set('returnTo', returnTo)
  }
  return recoveryUrl.toString()
}

export const Auth0LoginRedirect = ({ returnTo }: Auth0LoginRedirectProps) => {
  const { loginWithRedirect, isLoading, isAuthenticated } = useAuth0()

  useEffect(() => {
    if (isAuthenticated || isLoading) {
      return
    }

    loginWithRedirect({
      authorizationParams: {
        prompt: 'login',
      },
      appState: returnTo ? { returnTo } : undefined,
      openUrl: url => {
        window.location.replace(url)
      },
    })

    const stuckTimer = window.setTimeout(() => {
      window.location.replace(buildStuckLoginRecoveryUrl(returnTo))
    }, AUTH0_LOGIN_STUCK_TIMEOUT_MS)

    return () => window.clearTimeout(stuckTimer)
  }, [isAuthenticated, isLoading, loginWithRedirect, returnTo])

  if (isAuthenticated) {
    return <Navigate to={returnTo || '/'} replace />
  }

  return <LoadingLogo />
}

export default Auth0LoginRedirect
